var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 13,
    fill: "#A8ACB1",
    stroke: "#848B92"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 13,
    height: 1,
    fill: "#B8BABE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.90728L3 11V9.86093L5.97216 7.64901V7.62252L3 5.12583V4L7 7.41722V7.90728Z",
    fill: "#454C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H8V10H12V11Z",
    fill: "#454C54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8L18 5H24L21 8Z",
    fill: "#6A6C6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/console.37df58145a42e07e7b83331d31c16a4a.svg";
export { ForwardRef as ReactComponent };